import find from 'lodash/find';
import filter from 'lodash/filter';
import isNil from 'lodash/isNil';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';
import { RelationToUser } from '../../types/driver';

// Only shown in marital status AB test
export const MaritalStatusStep: Step = {
  id: 'askMaritalStatus',
  pathname: '/maritalstatus',
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    const selectedDrivers = filter(appData.tempDrivers, (driver) => !!driver.selected);
    const userDriver = find(selectedDrivers, (drv) => drv.relationToUser === RelationToUser.Insured);

    return !appData.isOnboardingLite && isNil(userDriver?.maritalStatus);
  },

  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    const userDriver = find(appData.drivers, (drv) => drv.relationToUser === RelationToUser.Insured);
    return !!userDriver?.maritalStatus;
  },
  category: () => StepCategory.Drivers,
  specialNextStep: {
    enable: (appData) => {
      return (
        appData.addingNewDriver?.variant === 'addSpouse' || appData.addingNewDriver?.variant === 'addDomesticPartner'
      );
    },
    nextStepId: 'adddriver',
  },
};
